<template>
  <div class="ml-2" v-if="websites.length > 1 && user?.type !== 'admin_delivery'">
    <autocomplete
      v-model="site"
      :items="websites"
      hide-details
      item-text="name"
      item-value="id"
      return-object
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SitesDropdown",
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),

    websites() {
      return this.user?.restaurants || [];
    },
    site: {
      get() {
        return this.$store.state.selectedRestaurant;
      },
      set(value) {
        this.$store.commit("SET_SELECTED_RESTAURANT", value);
      },
    },
  },
  watch: {
    websites: {
      handler: function (newWebsites) {
        if (newWebsites.length > 0 && !this.site) {
          this.$store.commit("SET_SELECTED_RESTAURANT", newWebsites[0]);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
/* Možemo dodati custom stilove ako je potrebno */
</style>
